module.exports = __webpack_public_path__ + "img/service_icon_01.3fe05372.png";